/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {BarChart, LineChart, PieChart} from '../../../components/Charts';
export const germanyGeneralData = {
  population: '83.7 million',
  laborForce: '43,848,015 (2021)',
  unemploymentRate: '2.7%',
  gdpPerCapita: '35,290 euros (2021)'
};
export const euClothingSpendingComparison = [{
  name: 'Luxembourg',
  value: 1130
}, {
  name: 'Austria',
  value: 810
}, {
  name: 'Netherlands',
  value: 770
}, {
  name: 'Denmark',
  value: 750
}, {
  name: 'Italy',
  value: 740
}, {
  name: 'Germany',
  value: 640
}, {
  name: 'EU Average',
  value: 490
}];
export const europeClothingSpending2018 = [{
  name: 'United Kingdom',
  value: 76
}, {
  name: 'Germany',
  value: 62.7
}, {
  name: 'Italy',
  value: 52.4
}, {
  name: 'France',
  value: 35.7
}, {
  name: 'Spain',
  value: 24.1
}];
export const fashionRetailSectors2020 = [{
  name: 'Apparel',
  companies: 13596,
  sales: 25843
}, {
  name: 'Textiles',
  companies: 8819,
  sales: 4786
}, {
  name: 'House and home textiles',
  companies: 3349,
  sales: 3212
}, {
  name: 'Shoes',
  companies: 3147,
  sales: 5252
}, {
  name: 'Leather goods',
  companies: 1039,
  sales: 997
}];
export const topSportsRetailers2020 = [{
  name: 'Decathlon',
  value: 667
}, {
  name: 'Sportscheck/Karstadt Sports',
  value: 317
}, {
  name: 'Globetrotter',
  value: 171
}, {
  name: 'Luckybike/Radlbauer',
  value: 156
}, {
  name: 'Bike & Outdoor Company',
  value: 104
}];
export const topFashionRetailers2018 = [{
  name: 'H&M',
  value: 2.60
}, {
  name: 'C&A',
  value: 2.45
}, {
  name: 'Deichmann',
  value: 1.82
}, {
  name: 'Kik',
  value: 1.45
}, {
  name: 'Peek & Cloppenburg',
  value: 1.10
}, {
  name: 'Ernstings Family',
  value: 1.09
}, {
  name: 'Primark',
  value: 0.90
}, {
  name: 'Takko',
  value: 0.72
}];
export const topOnlineFashionRetailers2020 = [{
  name: 'Zalando',
  value: 1.9
}, {
  name: 'H&M',
  value: 0.713
}, {
  name: 'Bonprix',
  value: 0.685
}, {
  name: 'About You',
  value: 0.572
}, {
  name: 'Baur',
  value: 0.501
}, {
  name: 'Best Secret',
  value: 0.362
}, {
  name: 'Limango',
  value: 0.285
}, {
  name: 'S. Oliver',
  value: 0.257
}];
export const topMarketplaces2020 = [{
  name: 'Amazon.de',
  value: 35.4
}, {
  name: 'Ebay.de',
  value: 11.8
}, {
  name: 'Otto.de',
  value: 5.5
}];
export const paymentMethods2021 = [{
  name: 'Invoice',
  value: 28.3
}, {
  name: 'PayPal',
  value: 28.2
}, {
  name: 'Direct debit',
  value: 17.4
}, {
  name: 'Other methods',
  value: 26.1
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    strong: "strong",
    h3: "h3",
    p: "p",
    em: "em"
  }, _provideComponents(), props.components), {ChartGrid} = _components;
  if (!ChartGrid) _missingMdxReference("ChartGrid", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "General data"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Metric"
          }), _jsx(_components.th, {
            children: "Value"
          }), _jsx(_components.th, {
            children: "Source"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Population:"
            })
          }), _jsx(_components.td, {
            children: "83.7 million"
          }), _jsx(_components.td, {
            children: "Destatis, July 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Labor force:"
            })
          }), _jsx(_components.td, {
            children: "43,848,015 (in 2021)"
          }), _jsx(_components.td, {
            children: "World Bank Open Data"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Unemployment rate:"
            })
          }), _jsx(_components.td, {
            children: "2.7%"
          }), _jsx(_components.td, {
            children: "Destatis, July 2022 & ILO May 2022"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.strong, {
              children: "Real GDP per capita:"
            })
          }), _jsx(_components.td, {
            children: "35,290 euros (in 2021)"
          }), _jsx(_components.td, {
            children: "Eurostat, July 2022"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      children: "Germany: the economy, household income & purchasing power"
    }), "\n", _jsx(_components.h3, {
      children: "Economy"
    }), "\n", _jsx(_components.p, {
      children: "Germany is the largest consumer market in the European Union, with a population of almost 83.2 million people."
    }), "\n", _jsx(_components.p, {
      children: "Source: International Trade Administration website, November 2021"
    }), "\n", _jsx(_components.p, {
      children: "Germany is also the largest economy in the European Union. Germany contributed 25.1% to the European GDP in 2020."
    }), "\n", _jsx(_components.p, {
      children: "Source: CBS in an article in July 2021 based on information by Eurostat"
    }), "\n", _jsx(_components.p, {
      children: "After the United States, China, and Japan, Germany is the fourth largest economy in the world."
    }), "\n", _jsx(_components.p, {
      children: "Source: WorldData.info, 2021"
    }), "\n", _jsx(_components.p, {
      children: "In 2021 Germany's Nominal GDP was $3.85 trillion, and it had a 4.54% share of the global economy."
    }), "\n", _jsx(_components.p, {
      children: "Source: Investopedia in an article, based on The World Bank data GDP 2020. Last updated in June, 2022"
    }), "\n", _jsx(_components.h3, {
      children: "Household income & purchasing power"
    }), "\n", _jsx(_components.p, {
      children: "Household disposable income per inhabitant of Germany, adjusted for price levels, in 2019 amounted to 30,100 euros per inhabitant."
    }), "\n", _jsx(_components.p, {
      children: "Source: CBS in an article in July 2021 based on information by Eurostat (Adjusted gross disposable income of households per capita in PPS)"
    }), "\n", _jsx(_components.p, {
      children: "In 2019, Germany had an average purchasing power of 23,779 euros per capita for spending and savings, 61% more than the European average of 14,739 euros."
    }), "\n", _jsx(_components.p, {
      children: "Source: GfK Purchasing Power Europe 2019, October 2019."
    }), "\n", _jsx(_components.h2, {
      children: "Clothing consumption, household expenditure and value spent per person"
    }), "\n", _jsx(_components.h3, {
      children: "German consumers buy a lot of clothes, but on average Germans spend less on individual clothing items than other nationalities do."
    }), "\n", _jsx(_components.p, {
      children: "As the largest economy in the EU and the four largest worldwide, Germany has one of the world's most significant consumer markets for the sale of fashion products."
    }), "\n", _jsx(_components.p, {
      children: "In fact, Germany is the fourth largest apparel and footwear market worldwide (see tab Global). The 2021 market size is $69.9 billion."
    }), "\n", _jsx(_components.p, {
      children: "Source: Euromonitor International, a market research provider"
    }), "\n", _jsx(_components.p, {
      children: "Final consumption expenditure on clothing and footwear of households reached a record high of 6.6% in December 1995 and a record low of 3.9% in December 2020."
    }), "\n", _jsx(_components.p, {
      children: "Source: Trading Economics based on information by Eurostat"
    }), "\n", _jsx(_components.p, {
      children: "Total expenditure on clothing and footwear rose by an annual average of 0.5% between 2010 and 2019 after adjusting for inflation."
    }), "\n", _jsx(_components.p, {
      children: "Source: Study 'Status of German Fashion' from The Fashion Council Germany, January 2021. Data: Eurostat, Final consumption expenditure of households by consumption purpose database"
    }), "\n", _jsx(_components.p, {
      children: "Household expenditure on Clothing & Footwear in Germany in 2020: 3.9% (as % of total expenditure)"
    }), "\n", _jsx(_components.p, {
      children: "Source: Household expenditure by category, European Union, 2020 (as % of total expenditure), Eurostat."
    }), "\n", _jsx(_components.p, {
      children: "Due to the corona pandemic, less was spent on clothing in 2020 than in previous years.\nHousehold expenditure on clothing and footwear in Germany was down by 12% in 2020."
    }), "\n", _jsx(_components.p, {
      children: "Source: Das Statistische Bundesamt (Destatis) Change in household expenditure, 2020 on 2019 %. November 2021"
    }), "\n", _jsx(_components.p, {
      children: "In 2020, Germans spent an average of 640 euros on clothing. Consumer spending on fashion is higher than the European average, which is 490 euros."
    }), "\n", _jsx(BarChart, {
      data: euClothingSpendingComparison,
      title: "European Clothing Spending per Capita 2020 (euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: Report Facts & Key figures 2022 of the European Textile and Clothing Industry van Euratex, June 2022. Data: EU household consumption of clothing in 2020. EUR at current prices, per capita, Eurostat"
    }), "\n", _jsx(_components.p, {
      children: "In 2019, Germans spent 76 billion euros on clothing and footwear, which leaves them just behind the UK as the highest spenders in Europe, and sixth highest in the world behind the larger economies of the US, China, India and Japan."
    }), "\n", _jsx(BarChart, {
      data: europeClothingSpending2018,
      title: "European Clothing Spending 2018 (billions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: Study 'Status of German Fashion' from The Fashion Council Germany, January 2021 Data: Sources: Consumer spending on clothing top 5 European Countries, 2019, Eurostat. & Figures from Oxford Economics' Global Economics database"
    }), "\n", _jsx(_components.p, {
      children: "In 2018 household spending on clothing in the EU was 62.7 billion euros."
    }), "\n", _jsx(_components.p, {
      children: "Source: Consumer spending on clothing in the European Union 2018, by country, Statista, July 2021"
    }), "\n", _jsx(_components.p, {
      children: "In that year German consumers spent an average of 760 euros on clothing per person."
    }), "\n", _jsx(_components.p, {
      children: "Source: Euratex Facts & Key Figures 2020 report. Data: EU household consumption of clothing in 2018, Eurostat."
    }), "\n", _jsx(_components.h3, {
      children: "The German consumer is price-sensitive and pragmatic"
    }), "\n", _jsx(_components.p, {
      children: "German consumers tend to be reserved and pragmatic when it comes to fashion. They prefer garments that are practical and can be worn on many occasions."
    }), "\n", _jsx(_components.p, {
      children: "The typical German customer who spends most on fashion is older than many might expect. \"The over-50 market makes up over 50% of the German market,\" said Ulla Ertelt, managing director of Frankfurt-based market research firm HML Marketing."
    }), "\n", _jsx(_components.p, {
      children: "German customers are well-informed and very demanding. They compare and look for the best deal - 'value for money' is a central term to the German worldview - before making a purchase."
    }), "\n", _jsx(_components.h2, {
      children: "Turnover, companies and employment in fashion"
    }), "\n", _jsx(_components.h2, {
      children: "The Fashion Industry makes a significant contribution to the German Economy"
    }), "\n", _jsx(_components.p, {
      children: "Fashion is a big economic factor in Germany. The fashion sector contributed 66 billion euros to the gross domestic product in 2019."
    }), "\n", _jsx(_components.p, {
      children: "Source: Study 'Status of German Fashion' from The Fashion Council Germany, January 2021"
    }), "\n", _jsx(_components.h2, {
      children: "Employment"
    }), "\n", _jsx(_components.p, {
      children: "Around 1.3 million people in Germany have employment thanks to the fashion industry.\n770,000 were employed directly by the industry."
    }), "\n", _jsx(_components.p, {
      children: "Source: Study 'Status of German Fashion' from The Fashion Council Germany, January 2021"
    }), "\n", _jsx(_components.h2, {
      children: "The German Textile and Fashion Industry"
    }), "\n", _jsx(_components.p, {
      children: "Turnover: 29 billion euros per year\n1400 companies\n124,000 employees"
    }), "\n", _jsx(_components.p, {
      children: "The German Textile and Fashion Industry is an important economic sector with an annual turnover of around 29 billion euros. The biggest growth driver is technical textiles: the turnover from technical textiles by German producers is approximately 13 billion euros per year. The annual turnover from fashion and clothing textiles is around 12 billion euros. The footwear and leather goods sector and the house and home textiles sector both achieve an annual turnover of 3 billion euros."
    }), "\n", _jsx(_components.p, {
      children: "Source: Textil-Mode.DE, The Confederation of the German Textile and Fashion Industry"
    }), "\n", _jsx(_components.h2, {
      children: "Companies and sales in the fashion trade 2020"
    }), "\n", _jsxs(ChartGrid, {
      children: [_jsx(BarChart, {
        data: fashionRetailSectors2020,
        title: "German Fashion Retail by Sector 2020 (companies)",
        dataKey: "companies",
        xAxisKey: "name",
        valueLabel: "Companies",
        layout: "vertical"
      }), _jsx(BarChart, {
        data: fashionRetailSectors2020,
        title: "German Fashion Retail Sales 2020 (millions euros)",
        dataKey: "sales",
        xAxisKey: "name",
        valuePrefix: "€",
        valueSuffix: "M",
        valueLabel: "Net Sales",
        layout: "vertical"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Source: Statistisches Bundesamt, Umsatzsteuerstatistiek. BTE Handelsverband Textil Schuhe Lederwaren. Source: BTE.DE"
    }), "\n", _jsx(_components.h2, {
      children: "Germany's largest fashion companies (brands & retailers)"
    }), "\n", _jsx(_components.p, {
      children: "Germany is best-known for its sporting goods sector. Some of the world's most renowned sports brands were founded there and are still based in the country. Well-known German fashion retailers are the Adidas Group, Puma, Hugo Boss, but also Otto Group, the German subsidiary of Swedish retailer H&M and C&A."
    }), "\n", _jsx(_components.h3, {
      children: "The sports retailers with the highest turnover in Germany (2021)"
    }), "\n", _jsx(BarChart, {
      data: topSportsRetailers2020,
      title: "Top Sports Retailers in Germany 2020 (millions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "M",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Decathlon is the sports retailer with the highest turnover in Germany. With a total of 81 sales outlets, the French sporting goods retailer and manufacturer achieved sales of 667 million euros in Germany in 2020."
    }), "\n", _jsx(_components.p, {
      children: "Together, the five largest sports retailers in Germany achieved sales of around 1.46 billion euros in 2020."
    }), "\n", _jsx(_components.p, {
      children: "Source: Statistik-Kompendium \"handelsdaten aktuell 2021\" from the EHI Retail Institute, retailers with largest 2020 sales numbers."
    }), "\n", _jsx(_components.h3, {
      children: "H&M tops sales rankings of stationary fashion retailers in Germany (2019)"
    }), "\n", _jsx(BarChart, {
      data: topFashionRetailers2018,
      title: "Top Fashion Retailers in Germany 2018 (billions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "The Swedish textile chain H&M is the sales leader in the stationary trade with fashion and accessories in Germany. H&M generated total sales of 2.60 billion euros with its 429 German branches in 2018."
    }), "\n", _jsx(_components.p, {
      children: "Source: Study from Forschungsinstitut EHI Retail Institute in October 2019"
    }), "\n", _jsx(_components.h2, {
      children: "German online retail continues to be dominated by heavyweights Amazon, Otto and Zalando."
    }), "\n", _jsx(_components.p, {
      children: "More about 'The largest Online Fashion retailers in Germany & Marketplaces 2020' in the paragraph E-commerce."
    }), "\n", _jsx(_components.p, {
      children: "Source: Study from Forschungsinstitut EHI Retail Institute in October 2021"
    }), "\n", _jsx(_components.h2, {
      children: "Germany's place in the global fashion economy: manufacturing & production"
    }), "\n", _jsx(_components.h3, {
      children: "Manufacturing"
    }), "\n", _jsx(_components.p, {
      children: "Germany is one of the largest producers of clothing in the EU. In 2018, the country's clothing manufacturing sector was worth 2.3 billion euros in terms of gross value added (GVA), behind Italy as the second largest producer in the EU27."
    }), "\n", _jsx(_components.p, {
      children: "Source: study 'Status of German Fashion' from The Fashion Council Germany, January 2021. Data: Gross value added is a measure of economic output. Eurostat, Structural Business Statistics database."
    }), "\n", _jsx(_components.p, {
      children: "Besides clothes, Germany is also a notable manufacturer of textiles. Plus the country specialises in producing machinery for textile, clothing and leather production."
    }), "\n", _jsx(_components.p, {
      children: "Source: study 'Status of German Fashion' from The Fashion Council Germany, January 2021."
    }), "\n", _jsx(_components.h3, {
      children: "Production"
    }), "\n", _jsx(_components.p, {
      children: "When it comes to production, the German fashion industry does more offshoring (i.e. the outsourcing of operations to other countries) than reshoring. The manufacturing output of clothing and footwear in Germany declined by 91% between 1980 and 2020 in terms of gross value added (after adjusting for inflation)."
    }), "\n", _jsx(_components.p, {
      children: "German consumers purchased 76 billion euros worth of clothing and footwear in 2019, but only 5% of that was made in domestic production facilities."
    }), "\n", _jsx(_components.p, {
      children: "Source: study 'Status of German Fashion' from The Fashion Council Germany, January 2021."
    }), "\n", _jsx(_components.h2, {
      children: "Germany: Significant imports and exports of fashion goods"
    }), "\n", _jsx(_components.p, {
      children: "In 2019, major trading partners in textiles and clothing for Germany were Poland, Switzerland, Austria, France and the Netherlands for exports. China, Bangladesh, Turkey, Italy and India were important partners for the import business."
    }), "\n", _jsx(_components.p, {
      children: "Source: WITS Worldbank 'Germany Textiles and Clothing Exports, imports, tariffs, by country and region 2019'"
    }), "\n", _jsx(_components.p, {
      children: "Regarding Export:\nIn 2018, Germany ranked third in the world for textile exports, fifth for clothing exports, and fourth for footwear exports."
    }), "\n", _jsx(_components.p, {
      children: "Source: study 'Status of German Fashion' from The Fashion Council Germany, January 2021."
    }), "\n", _jsx(_components.p, {
      children: "Regarding Import: Germany was the world's second-largest importer of clothing and footwear and the fifth-largest importer of textiles."
    }), "\n", _jsx(_components.p, {
      children: "Source: study 'Status of German Fashion' from The Fashion Council Germany, January 2021. Data: Destatis"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Germany is the biggest importer of clothing in the EU (in 2020)"
      })
    }), "\n", _jsx(_components.p, {
      children: "In 2020, almost 17 billion euros worth of clothes were imported by Germany from outside the EU (25% of total extra-EU imports of clothes imports by value). Germany imports more clothing from non-EU countries than any other EU member state."
    }), "\n", _jsx(_components.p, {
      children: "Source: Eurostat news \"Where do our clothes come from?\", April 2021 & Statista Chart Where The EU Imports Its Clothes From, April 2021."
    }), "\n", _jsx(_components.h2, {
      children: "E-commerce"
    }), "\n", _jsx(_components.h3, {
      children: "General"
    }), "\n", _jsx(_components.p, {
      children: "Retail sales from e-commerce have more than doubled over the past decade across Europe. In Germany, online sales growth has been even more. But, statistically speaking, e-commerce appears to be less widespread in Germany than in other European countries. The Covid-19 pandemic caused a massive increase in online activity here in 2020 as it has worldwide."
    }), "\n", _jsx(_components.p, {
      children: "In 2020, 82% of consumers in Germany shopped online which puts the country in 7th place in the EU."
    }), "\n", _jsx(_components.p, {
      children: "Source: Destatis, based on Eurostat data, Internet purchases by individuals 2020 onwards"
    }), "\n", _jsx(_components.h3, {
      children: "Retail e-commerce sales compared to the total retail trade"
    }), "\n", _jsx(_components.p, {
      children: "German retailers are less likely to accept e-commerce than other European countries. 28% of retailers in Germany attributed at least 1% of their revenue to online sales in 2019."
    }), "\n", _jsx(_components.p, {
      children: "Source: study 'Status of German Fashion' from The Fashion Council Germany, January 2021"
    }), "\n", _jsx(_components.h3, {
      children: "Revenue Fashion E-commerce"
    }), "\n", _jsx(_components.p, {
      children: "Germany's fashion e-commerce (clothes and shoes) amounted to 18.7 billion euros in revenue in 2019."
    }), "\n", _jsx(_components.p, {
      children: "Source: study 'Status of German Fashion' from The Fashion Council Germany, January 2021. Data: Statista, Umsatz im Online-Modehandel in Deutschland in den Jahren 2006 bis 2019, 2020."
    }), "\n", _jsx(_components.h3, {
      children: "The largest online fashion retailers and marketplaces in Germany (2020)"
    }), "\n", _jsx(_components.p, {
      children: "The ranking of online shops with the highest turnover is led by industry leader Amazon with a net e-commerce turnover of 13.9 billion euros in Germany in 2020. Otto is the second largest online retailer with a turnover of 4.5 billion euros. You find Zalando with a turnover of 1.9 billion euros in third place."
    }), "\n", _jsx(BarChart, {
      data: topOnlineFashionRetailers2020,
      title: "Top Online Fashion Retailers Germany 2020 (billions euros)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "B",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: Textilwirtschaft based on the Study E-Commerce-Markt Deutschland 2021 by EHI Retail Institute & Statista (Netto E-commerce umsatz B2C-Onlineshops im Geschäftsjahr 2020), October 2021"
    }), "\n", _jsx(_components.p, {
      children: "Selected marketplaces in Germany in 2020:"
    }), "\n", _jsx(BarChart, {
      data: topMarketplaces2020,
      title: "Top Marketplaces Germany 2020 (millions euros GMV)",
      dataKey: "value",
      xAxisKey: "name",
      valuePrefix: "€",
      valueSuffix: "M",
      layout: "vertical"
    }), "\n", _jsx(_components.p, {
      children: "Source: Study E-Commerce-Markt Deutschland 2021 by EHI Retail Institute & Statista, October 2021"
    }), "\n", _jsx(_components.h2, {
      children: "German Online shoppers prefer to pay by invoice or PayPal"
    }), "\n", _jsx(PieChart, {
      data: paymentMethods2021,
      title: "Online Payment Methods in Germany 2021 (%)",
      dataKey: "value",
      nameKey: "name",
      valueSuffix: "%"
    }), "\n", _jsx(_components.p, {
      children: "While 30.4% of all online purchases in 2020 in Germany were paid by invoice, the share dropped to 28.3% in 2021. Paying with the online payment service PayPal is growing in popularity among German consumers. PayPal was able to increase its German market share from 24.9 to 28.2%. In third place in the popularity ranking of online payment methods is direct debit with a share of 17.4%, slightly lower than it was in the year before."
    }), "\n", _jsx(_components.p, {
      children: "Source: DPA, based on Kolner Handelsforschungsinstitut EHI, Study \"Online-Payment 2022\""
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Last update: July 2022."
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
